<template>
  <div>
    <div class="row" style="margin-top: -30px;">
      <div class="col-xl-10"></div>
    </div>
    <hr />
    <div class="row">
      <div class="col-xl-2">
        <label>Moneda</label>
      </div>
      <div class="col-xl-2">
        <label>Cambio</label>
      </div>

      <div class="col-xl-6"></div>
      <div class="col-xl-2">
        <label>Periodo</label>
      </div>
      <div class="col-xl-2 tipoCambioUF" v-if="this.tipoCambioUF">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >UF</span
        >
      </div>
      <div class="col-xl-2" v-else></div>
      <div class="col-xl-2 tipoCambioUF" v-if="this.tipoCambioUF">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearUF(this.comisionesUf.tipoCambio) }}</span
        >
      </div>
      <div class="col-xl-2" v-else></div>
      <div class="col-xl-6"></div>
      
      <div class="col-xl-2">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          > {{comision[0].anio  }}-{{ comision[0].mes }}</span
        >
      </div>
      <div class="col-xl-2 tipoCambioUS" v-if="this.tipoCambioUS">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >US$</span
        >
      </div>
      <div class="col-xl-2 tipoCambioUS" v-if="this.tipoCambioUS">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearDolar(this.comisionesDolar.tipoCambio) }}</span
        >
      </div>
      <div class="col-xl-2 tipoCambioUTM" v-if="this.tipoCambioUTM">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >UTM</span
        >
      </div>
      <div class="col-xl-2 tipoCambioUTM" v-if="this.tipoCambioUTM">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ this.comisionesUTM.tipoCambio }}</span
        >
      </div>
      <div class="col-xl-2 tipoCambioEUR" v-if="this.tipoCambioEUR">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >EUR</span
        >
      </div>
      <div class="col-xl-2 tipoCambioEUR" v-if="this.tipoCambioEUR">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearEuro(this.comisionesEuro.tipoCambio) }}</span
        >
      </div>
      <div class="col-xl-2 tipoCambioDA" v-if="this.tipoCambioDA">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >DA</span
        >
      </div>
      <div class="col-xl-2 tipoCambioDA" v-if="this.tipoCambioDA">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearEuro(this.comisionesDA.tipoCambio) }}</span
        >
      </div>
      <div class="col-xl-8 tipoCambioASB"></div>  
      <div class="col-xl-2 tipoCambioASB" v-if="this.tipoCambioASB">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >ASB</span
        >
      </div>
      <div class="col-xl-2 tipoCambioASB" v-if="this.tipoCambioASB">
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearEuro(this.comisionesASB.tipoCambio) }}</span
        >
      </div>
      <div class="col-xl-8 tipoCambioASB"></div>  
    </div>
    <div class="row"  v-if="retencionOpcional">
      
      <div class="col-xl-2">
        <label>Retención</label>
      </div>
      
      <div class="col-xl-2">
        <v-radio-group  column v-model="valorRetencion">
          <v-radio
            color="red darken-3"
            :key="item.idRetencion"
            :label="item.valor + '%'"
            :value="item.valor"
            v-for="item in listaRetenciones"
            @change="calcularImpuesto(item)"
          ></v-radio>
        </v-radio-group>
      </div>
    </div>

    <v-divider inset width="250"></v-divider>
<!-- UF -->
    <div
      class="row fondoUf tipoCambioUF"
      style="border-top-left-radius: 10px; border-top-right-radius: 10px; margin-top:15px"
      v-if="this.tipoCambioUF && this.existeAfectaUF"
    >
      <h5 class="col-xl-12 ajusteTexto">Comisiones Afectas UF</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
          
          formatearUF(this.comisionesUf.afecta.montoAfectaUF)
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.afecta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.afecta.impuestoClp) }}</span
        >
      </div>

      <div class="col-xl-3">
        <label>Total Afecto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.afecta.afectoNeto) }}</span
        >
      </div>
    </div>
    <div
      class="row fondoUf tipoCambioUF"
      v-if="this.tipoCambioUF && this.existeExentaUF"
    >
      <h5 class="col-xl-12 ajusteTexto">Comisiones Exentas UF</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatearUF(this.comisionesUf.exenta.montoExentaUF)
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.exenta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.exenta.impuestoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Total Exento CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.exenta.exentoNeto) }}</span
        >
      </div>
      <div class="col-xl-12">
        <hr class="divisor" />
      </div>
    </div>
    <!-- UF -->
    <!-- DÓLAR -->
    <div
      class="row fondoDolar tipoCambioUS"
      style="border-top-left-radius: 10px; border-top-right-radius: 10px; margin-top:25px"
      v-if="this.tipoCambioUS && this.existeAfectaUS"
    >
      <br />
      <h5 class="col-xl-12 ajusteTexto">Comisiones Afectas US$</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatearDolar(this.comisionesDolar.afecta.montoAfectaUF)
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDolar.afecta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDolar.afecta.impuestoClp) }}</span
        >
      </div>

      <div class="col-xl-3">
        <label>Total Afecto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDolar.afecta.afectoNeto) }}</span
        >
      </div>
    </div>
    <div
      class="row fondoDolar tipoCambioUS"
      v-if="this.tipoCambioUS && this.existeExentaUS"
    >
      <h5 class="col-xl-12 ajusteTexto">Comisiones Exentas US$</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ 
            formatearDolar(this.comisionesDolar.exenta.montoExentaUF)
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDolar.exenta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDolar.exenta.impuestoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Total Exento CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDolar.exenta.exentoNeto) }}</span
        >
      </div>
      <div class="col-xl-12">
        <hr class="divisor" />
      </div>
    </div>
    <!-- DÓLAR -->
    <!-- UTM -->
    <div
      class="row fondoUTM tipoCambioUTM"
      style="border-top-left-radius: 10px; border-top-right-radius: 10px; margin-top:25px"
      v-if="this.tipoCambioUTM && this.existeAfectaUTM"
    >
      <br />
      <h5 class="col-xl-12 ajusteTexto">Comisiones Afectas UTM</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatoUF(this.comisionesUTM.afecta.montoComision.toFixed(3))
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUTM.afecta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUTM.afecta.impuestoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Total Afecto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUTM.afecta.afectoNeto) }}</span
        >
      </div>
    </div>
    <div
      class="row fondoUTM tipoCambioUTM"
      v-if="this.tipoCambioUTM && this.existeExentaUTM"
    >
      <h5 class="col-xl-12 ajusteTexto">Comisiones Exentas UTM</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatoUF(this.comisionesUTM.exenta.montoComision.toFixed(3))
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUTM.exenta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUTM.exenta.impuestoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Total Exento CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUTM.exenta.exentoNeto) }}</span
        >
      </div>
      <div class="col-xl-12">
        <hr class="divisor" />
      </div>
    </div>
    <!-- UTM -->
    <!-- EURO -->
    <div
      class="row fondoEuro tipoCambioEUR"
      style="border-top-left-radius: 10px; border-top-right-radius: 10px; margin-top:25px"
      v-if="this.tipoCambioEUR && this.existeAfectaEUR"
    >
      <br />
      <h5 class="col-xl-12 ajusteTexto">Comisiones Afectas Euro</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatearEuro(this.comisionesEuro.afecta.montoAfectaUF)
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesEuro.afecta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesEuro.afecta.impuestoClp) }}</span
        >
      </div>

      <div class="col-xl-3">
        <label>Total Afecto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesEuro.afecta.afectoNeto) }}</span
        >
      </div>
    </div>
    <div
      class="row fondoEuro tipoCambioEUR"
      v-if="this.tipoCambioEUR && this.existeExentaEUR"
    >
      <h5 class="col-xl-12 ajusteTexto">Comisiones Exentas Euro</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatearEuro(this.comisionesEuro.exenta.montoExentaUF)
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesEuro.exenta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesEuro.exenta.impuestoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Total Exento CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesEuro.exenta.exentoNeto) }}</span
        >
      </div>
      <div class="col-xl-12">
        <hr class="divisor" />
      </div>
    </div>
    <!-- EURO -->
    <!-- DA -->
    <div
      class="row fondoEuro tipoCambioDA"
      style="border-top-left-radius: 10px; border-top-right-radius: 10px; margin-top:25px"
      v-if="this.tipoCambioDA && this.existeAfectaDA"
    >
      <br />
      <h5 class="col-xl-12 ajusteTexto">Comisiones Afectas DA</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatearEuro(this.comisionesDA.afecta.montoAfectaUF)
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDA.afecta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDA.afecta.impuestoClp) }}</span
        >
      </div>

      <div class="col-xl-3">
        <label>Total Afecto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDA.afecta.afectoNeto) }}</span
        >
      </div>
    </div>
    <div
      class="row fondoEuro tipoCambioDA"
      v-if="this.tipoCambioDA && this.existeExentaDA"
    >
      <h5 class="col-xl-12 ajusteTexto">Comisiones Exentas DA</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
           formatearEuro(this.comisionesDA.exenta.montoExentaUF)
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDA.exenta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDA.exenta.impuestoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Total Exento CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesDA.exenta.exentoNeto) }}</span
        >
      </div>
      <div class="col-xl-12">
        <hr class="divisor" />
      </div>
    </div>
    <!-- DA -->
    <!-- ASB -->
    <div
      class="row fondoEuro tipoCambioASB"
      style="border-top-left-radius: 10px; border-top-right-radius: 10px; margin-top:25px"
      v-if="this.tipoCambioASB && this.existeAfectaASB"
    >
      <br />
      <h5 class="col-xl-12 ajusteTexto">Comisiones Afectas ASB</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatearEuro(this.comisionesASB.afecta.montoAfectaUF)
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesASB.afecta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesASB.afecta.impuestoClp) }}</span
        >
      </div>

      <div class="col-xl-3">
        <label>Total Afecto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesASB.afecta.afectoNeto) }}</span
        >
      </div>
    </div>
    <div
      class="row fondoEuro tipoCambioASB"
      v-if="this.tipoCambioASB && this.existeExentaASB"
    >
      <h5 class="col-xl-12 ajusteTexto">Comisiones Exentas ASB</h5>
      <div class="col-xl-3">
        <label>Comisión M/O</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
           formatearEuro(this.comisionesASB.exenta.montoExentaUF)
          }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesASB.exenta.montoNetoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesASB.exenta.impuestoClp) }}</span
        >
      </div>
      <div class="col-xl-3">
        <label>Total Exento CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesASB.exenta.exentoNeto) }}</span
        >
      </div>
      <div class="col-xl-12">
        <hr class="divisor" />
      </div>
    </div>
    <!-- ASB -->

    <!--TOTALIZADOR BOLETA-->
    <div
      class="row fondoUf"
      style="border-radius: 10px; margin-top:25px"
      v-if="(this.tipoCambioUF && this.comisionesUf.tipoDocumento == 'BOLETA') 
       || (this.tipoCambioUS &&  this.comisionesDolar.tipoDocumento == 'BOLETA') 
      || (this.tipoCambioEUR &&  this.comisionesEuro.tipoDocumento == 'BOLETA') 
      || (this.tipoCambioUTM &&  this.comisionesUTM.tipoDocumento == 'BOLETA') 
      || (this.tipoCambioASB &&  this.comisionesASB.tipoDocumento == 'BOLETA') 
      || (this.tipoCambioDA &&  this.tipoCambioDA.tipoDocumento == 'BOLETA') "
    >
    <br />
          <br />
      <h5 class="col-xl-12 ajusteTexto">
        Total Comisiones
      </h5>
      <div class="col-xl-4">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.total.netoTotalAfecta + this.comisionesUf.total.netoTotalExenta ) }}</span
        >
      </div>
      <div class="col-xl-4">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatearPesos( parseInt(this.comisionesUf.total.impuestoTotalAfecta) + parseInt(this.comisionesUf.total.impuestoTotalExenta))
          }}</span
        >
      </div>
      <div class="col-xl-4">
        <label>Total CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.total.totalAfecta + this.comisionesUf.total.totalExenta) }}</span
        >
      </div>
    </div>
    <!--TOTALIZADOR BOLETA-->

    <!--TOTAL AFECTA UF-->
    <div
      class="row fondoUf existeAfecta"
      style="border-radius: 10px; margin-top:25px"
      v-if="this.existeAfecta && (this.tipoCambioUF &&  this.comisionesUf.tipoDocumento != 'BOLETA')
      || this.existeAfecta  &&  (this.tipoCambioUS && this.comisionesDolar.tipoDocumento != 'BOLETA')
      || this.existeAfecta  &&  (this.tipoCambioEUR && this.comisionesEuro.tipoDocumento != 'BOLETA')
      || this.existeAfecta  &&  (this.tipoCambioUTM && this.comisionesUTM.tipoDocumento != 'BOLETA')
      || this.existeAfecta  &&  (this.tipoCambioASB && this.comisionesASB.tipoDocumento != 'BOLETA')
      || this.existeAfecta  &&  (this.tipoCambioDA && this.comisionesDA.tipoDocumento != 'BOLETA')
        "
    >
      <br />
      <h5 class="col-xl-12 ajusteTexto">
        Total Comisiones Afectas
      </h5>
      <div class="col-xl-4">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.total.netoTotalAfecta) }}</span
        >
      </div>
      <div class="col-xl-4">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatearPesos(this.comisionesUf.total.impuestoTotalAfecta)
          }}</span
        >
      </div>
      <div class="col-xl-4">
        <label>Total CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.total.totalAfecta) }}</span
        >
      </div>
    </div>
    <!--TOTAL AFECTA UF-->
 <!--EXENTA UF-->
    <div
      class="row fondoUf existeExenta"
      style="border-radius: 10px; margin-top:15px"
      v-if="this.existeExenta && (this.tipoCambioUF && this.comisionesUf.tipoDocumento != 'BOLETA')
      || this.existeExenta  && (this.tipoCambioUS && this.comisionesDolar.tipoDocumento != 'BOLETA')
      || this.existeExenta  && (this.tipoCambioEUR && this.comisionesEuro.tipoDocumento != 'BOLETA')
      || this.existeExenta  && (this.tipoCambioUTM && this.comisionesUTM.tipoDocumento != 'BOLETA')
      || this.existeExenta  && (this.tipoCambioASB && this.tipoCambioASB.tipoDocumento != 'BOLETA')
      || this.existeExenta  && (this.tipoCambioDA && this.tipoCambioDA.tipoDocumento != 'BOLETA')
      "
    >
      <br />
      <h5 class="col-xl-12 ajusteTexto">
        Total Comisiones Exentas
      </h5>
      <div class="col-xl-4">
        <label>Monto Neto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.total.netoTotalExenta) }}</span
        >
      </div>
      <div class="col-xl-4">
        <label>Impuesto CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{
            formatearPesos(this.comisionesUf.total.impuestoTotalExenta)
          }}</span
        >
      </div>
      <div class="col-xl-4">
        <label>Total CLP</label>
        <span
          class="form-control bordeFormulario form-control-lg"
          disabled="disabled"
          >{{ formatearPesos(this.comisionesUf.total.totalExenta) }}</span
        >
      </div>
    </div>
     <!--EXENTA UF-->
    <br />
    <hr />
    <div
      v-show="this.esNegativo == false  && subirDocumentos.permitir == true"
      class="alert alert-custom alert-notice alert-light-success fade show p-2"
      role="alert"
      v-if="comision.estado != 'APROBADO'"
    >
      <div class="alert-text font-size-sm">
        <strong>Estimad@ Corredor</strong>, Ingrese los montos correspondientes
        a la factura y/o boleta y luego adjunte el documento
      </div>
    </div>

    <div
      v-show="this.esNegativo == false && subirDocumentos.permitir == true"
      class="alert alert-custom alert-notice alert-light-warning fade show p-2"
      role="alert"
      v-if="comision.estado != 'APROBADO'"
    >
      <div class="alert-text font-size-sm">
        Ingrese los montos sin puntos, <strong> EJ: 100.000 = 100000</strong>
      </div>
    </div>

    <b-alert
      v-show="this.esNegativo == false"
      :class="'alert-light-' + mensaje.tipoMensaje"
      class="alert-custom alert-notice alert-custom-send-mail-succsess"
      v-model="mensaje.mostrar"
      :variant="mensaje.tipoMensaje"
      dismissible
    >
      <div class="alert-text">
        <div><strong>Estimad@</strong>, {{ mensaje.titulo }}</div>
        <br />
        <ul>
          <li v-for="(item, index) in mensaje.mensajes" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>

      <template v-slot:dismiss>
        <div class="alert-close">
          <span aria-hidden="true">
            <i class="la la-close"></i>
          </span>
        </div>
      </template>
    </b-alert>
    <hr v-show="this.esNegativo == false && subirDocumentos.permitir == true" />
  <div
      class="alert alert-custom alert-notice alert-light-success fade show p-2"
      role="alert"
     v-if="subirDocumentos.permitir == false"
    >
      <div class="alert-text font-size-lg">
        <strong>Estimad@ Corredor</strong>, Los dias {{subirDocumentos.inicio}} al {{subirDocumentos.fin}} no se pueden cargar documentos
      </div>
    </div>
    <b-form
      class="form"
      @submit.stop.prevent="onSubmitformEnviarBoletaFactura"
      v-if="comision.estado != 'APROBADO' && subirDocumentos.permitir == true"
      id="formLiquidacion"
    >

    <!-- INPUTS BOLETA -->
      <div
          v-if="this.comisionesUf.tipoDocumento == 'BOLETA' 
          || this.comisionesDolar.tipoDocumento == 'BOLETA'
          || this.comisionesEuro.tipoDocumento == 'BOLETA'
          || this.comisionesUTM.tipoDocumento == 'BOLETA'
          || this.comisionesASB.tipoDocumento == 'BOLETA'
          || this.comisionesDA.tipoDocumento == 'BOLETA'
           "
        v-show="this.esNegativo == false"
        class=""
      >
        <h5 class="col-xl-12 ajusteTexto">
          <span v-if="this.mesajeFacturaAfecta">Boleta por Comision</span>
         
        </h5>
        <b-row>
          <b-form-group label label-for="numeroDocumento" class="col-4 mb-0">
            <b-form-input
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="numeroDocumento"
              type="number"
              name="numeroDocumento"
              v-model="$v.form.numeroDocumento.$model"
              :state="validateState('numeroDocumento')"
              aria-describedby="numeroDocumento-mensaje-validacion"
              placeholder="Número Documento"
            ></b-form-input>
            <b-form-invalid-feedback id="numeroDocumento-mensaje-validacion"
              >El Numero Documento es obligatorio.</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            label
            label-for="fechaFacturacionBoleta"
            class="col-8 mb-0"
          >
            <b-form-datepicker
              class="h-auto py-1 px-6 bordeFormulario"
              id="fechaFacturacionBoleta"
              name="fechaFacturacionBoleta"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              v-model="$v.form.fechaFacturacionBoleta.$model"
              :state="validateState('fechaFacturacionBoleta')"
              aria-describedby="fechaFacturacionBoleta-mensaje-validacion"
              locale="es"
              placeholder="Seleccionar fecha boleta/Factura"
            ></b-form-datepicker>
            <b-form-invalid-feedback
              id="fechaFacturacionBoleta-mensaje-validacion"
              >Fecha Boleta/Factura es obligatorio.</b-form-invalid-feedback
            >
          </b-form-group>
        </b-row>

        <b-row
          class="fondoUf"
          style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
        >
          <b-form-group label label-for="montoNetoAfecta" class="col mb-0">
            <b-form-input
            v-on:keypress="validarNumero($event)"
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="montoNetoAfecta"
              type="number"
              name="montoNetoAfecta"
              v-model="$v.form.montoNetoAfecta.$model"
              :state="validateState('montoNetoAfecta')"
              aria-describedby="montoNetoAfecta-mensaje-validacion"
              placeholder="Monto Neto"
            ></b-form-input>
            <b-form-invalid-feedback id="montoNetoAfecta-mensaje-validacion"
              >El Monto Neto es obligatorio, sin puntos ni comas.</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label label-for="ivaAfecta" class="col mb-0">
            <b-form-input
            v-on:keypress="validarNumero($event)"
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="ivaAfecta"
              type="number"
              name="ivaAfecta"
              v-model="$v.form.ivaAfecta.$model"
              :state="validateState('ivaAfecta')"
              aria-describedby="ivaAfecta-mensaje-validacion"
              placeholder="Impuesto "
            ></b-form-input>
            <b-form-invalid-feedback id="ivaAfecta-mensaje-validacion"
              >El Iva Afecta es obligatorio, sin puntos ni comas.</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label label-for="montoTotalAfecta" class="col-md mb-0">
            <b-form-input
            v-on:keypress="validarNumero($event)"
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="montoTotalAfecta"
              type="number"
              name="montoTotalAfecta"
              v-model="$v.form.montoTotalAfecta.$model"
              :state="validateState('montoTotalAfecta')"
              aria-describedby="montoTotalAfecta-mensaje-validacion"
              placeholder="Monto Total "
            ></b-form-input>
            <b-form-invalid-feedback id="montoTotalAfecta-mensaje-validacion"
              >El Monto Total Afecta obligatorio, sin puntos ni comas.</b-form-invalid-feedback
            >
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group class="mb-3 col" label label-for="boletaFactura">
            <b-form-file
              name="boletaFactura_1"
              id="boletaFactura_1"
              :placeholder="mesajeFacturaAfecta  == true ? 'Adjuntar Boleta o Factura en formato PDF' : 'Adjuntar Nota de crédito en formato PDF'"
              accept=".pdf"
              @change="cargarArchivos($event, item)"
            ></b-form-file>
          </b-form-group>
        </b-row>
      </div>
<!-- INPUTS BOLETA -->

      <!--INPUTS AFECTA -->
      <div
        v-if="this.existeAfecta &&  (this.tipoCambioUF && this.comisionesUf.tipoDocumento != 'BOLETA')
              || this.existeAfecta && (this.tipoCambioUS &&  this.comisionesDolar.tipoDocumento != 'BOLETA')
              || this.existeAfecta && (this.tipoCambioEUR &&  this.comisionesEuro.tipoDocumento != 'BOLETA')
              || this.existeAfecta && (this.tipoCambioUTM &&  this.comisionesUTM.tipoDocumento != 'BOLETA')
              || this.existeAfecta && (this.tipoCambioASB &&  this.comisionesASB.tipoDocumento != 'BOLETA')
              || this.existeAfecta && (this.tipoCambioDA &&  this.comisionesDA.tipoDocumento != 'BOLETA')
              "
        v-show="this.esNegativo == false"
        class="existeAfecta"
      >
        <h5 class="col-xl-12 ajusteTexto">
          <span v-if="this.mesajeFacturaAfecta">Factura Por Comisiones de Coberturas Afectas</span>
          <span v-if="this.mesajeFacturaAfecta == false">Nota de Crédito Por Comisiones de Coberturas Afectas</span> 
        </h5>
        <b-row>
          <b-form-group label label-for="numeroDocumento" class="col-4 mb-0">
            <b-form-input
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="numeroDocumento"
              type="number"
              name="numeroDocumento"
              v-model="$v.form.numeroDocumento.$model"
              :state="validateState('numeroDocumento')"
              aria-describedby="numeroDocumento-mensaje-validacion"
              placeholder="Número Documento"
            ></b-form-input>
            <b-form-invalid-feedback id="numeroDocumento-mensaje-validacion"
              >El Numero Documento es obligatorio.</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            label
            label-for="fechaFacturacionBoleta"
            class="col-8 mb-0"
          >
            <b-form-datepicker
              class="h-auto py-1 px-6 bordeFormulario"
              id="fechaFacturacionBoleta"
              name="fechaFacturacionBoleta"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              v-model="$v.form.fechaFacturacionBoleta.$model"
              :state="validateState('fechaFacturacionBoleta')"
              aria-describedby="fechaFacturacionBoleta-mensaje-validacion"
              locale="es"
              placeholder="Seleccionar fecha boleta/Factura"
            ></b-form-datepicker>
            <b-form-invalid-feedback
              id="fechaFacturacionBoleta-mensaje-validacion"
              >Fecha Boleta/Factura es obligatorio.</b-form-invalid-feedback
            >
          </b-form-group>
        </b-row>

        <b-row
          class="fondoUf"
          style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
        >
          <b-form-group label label-for="montoNetoAfecta" class="col mb-0">
            <b-form-input
            v-on:keypress="validarNumero($event)"
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="montoNetoAfecta"
              type="number"
              name="montoNetoAfecta"
              v-model="$v.form.montoNetoAfecta.$model"
              :state="validateState('montoNetoAfecta')"
              aria-describedby="montoNetoAfecta-mensaje-validacion"
              placeholder="Monto Neto"
            ></b-form-input>
            <b-form-invalid-feedback id="montoNetoAfecta-mensaje-validacion"
              >El Monto Neto es obligatorio, sin puntos ni comas.</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label label-for="ivaAfecta" class="col mb-0">
            <b-form-input
            v-on:keypress="validarNumero($event)"
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="ivaAfecta"
              type="number"
              name="ivaAfecta"
              v-model="$v.form.ivaAfecta.$model"
              :state="validateState('ivaAfecta')"
              aria-describedby="ivaAfecta-mensaje-validacion"
              placeholder="Impuesto Afecta"
            ></b-form-input>
            <b-form-invalid-feedback id="ivaAfecta-mensaje-validacion"
              >El Iva Afecta es obligatorio, sin puntos ni comas.</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label label-for="montoTotalAfecta" class="col-md mb-0">
            <b-form-input
            v-on:keypress="validarNumero($event)"
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="montoTotalAfecta"
              type="number"
              name="montoTotalAfecta"
              v-model="$v.form.montoTotalAfecta.$model"
              :state="validateState('montoTotalAfecta')"
              aria-describedby="montoTotalAfecta-mensaje-validacion"
              placeholder="Monto Total Afecta"
            ></b-form-input>
            <b-form-invalid-feedback id="montoTotalAfecta-mensaje-validacion"
              >El Monto Total Afecta obligatorio, sin puntos ni comas.</b-form-invalid-feedback
            >
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group class="mb-3 col" label label-for="boletaFactura">
            <b-form-file
              name="boletaFactura_2"
              id="boletaFactura_2"
              :placeholder="mesajeFacturaAfecta  == true ? 'Adjuntar Boleta o Factura en formato PDF' : 'Adjuntar Nota de crédito en formato PDF'"
              accept=".pdf"
              @change="cargarArchivos($event, item)"
            ></b-form-file>
          </b-form-group>
        </b-row>
      </div>
      <br />
      <!--INPUTS AFECTA -->

       <!--INPUTS EXENTA -->
      <div
        v-if="this.existeExenta &&  (this.tipoCambioUF && this.comisionesUf.tipoDocumento != 'BOLETA')
            || this.existeExenta && (this.tipoCambioUS &&  this.comisionesDolar.tipoDocumento != 'BOLETA')
            || this.existeExenta && (this.tipoCambioEUR &&  this.comisionesEuro.tipoDocumento != 'BOLETA')
            || this.existeExenta && (this.tipoCambioUTM &&  this.comisionesUTM.tipoDocumento != 'BOLETA')
            || this.existeExenta && (this.tipoCambioASB &&  this.comisionesASB.tipoDocumento != 'BOLETA')
            || this.existeExenta && (this.tipoCambioDA &&  this.comisionesDA.tipoDocumento != 'BOLETA')
            "        
        v-show="this.esNegativo == false"
        class="existeExenta"
      >
        <h5 class="col-xl-12 ajusteTexto">
          <span v-show="this.mesajeFacturaExenta">Factura Por Comisiones de Coberturas Exentas</span>
          <span v-show="this.mesajeFacturaExenta == false">Nota de Crédito Por Comisiones de Coberturas Exentas</span> 
        </h5>
        <b-row>
          <b-form-group
            label
            label-for="numeroDocumentoExenta"
            class="col-4 mb-0"
          >
            <b-form-input
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="numeroDocumentoExenta"
              type="number"
              name="numeroDocumentoExenta"
              v-model="$v.form.numeroDocumentoExenta.$model"
              :state="validateState('numeroDocumentoExenta')"
              aria-describedby="numeroDocumentoExenta-mensaje-validacion"
              placeholder="Número Documento"
            ></b-form-input>
            <b-form-invalid-feedback
              id="numeroDocumentoExenta-mensaje-validacion"
              >El Numero Documento es obligatorio.</b-form-invalid-feedback
            >
          </b-form-group>

          <b-form-group
            label
            label-for="fechaFacturacionBoletaExenta"
            class="col-8 mb-0"
          >
            <b-form-datepicker
              class="h-auto py-1 px-6 bordeFormulario"
              id="fechaFacturacionBoletaExenta"
              name="fechaFacturacionBoletaExenta"
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              v-model="$v.form.fechaFacturacionBoletaExenta.$model"
              :state="validateState('fechaFacturacionBoletaExenta')"
              aria-describedby="fechaFacturacionBoletaExenta-mensaje-validacion"
              locale="es"
              placeholder="Seleccionar fecha boleta/Factura"
            ></b-form-datepicker>
            <b-form-invalid-feedback
              id="fechaFacturacionBoletaExenta-mensaje-validacion"
              >Fecha Boleta/Factura es obligatorio.</b-form-invalid-feedback
            >
          </b-form-group>
        </b-row>

        <b-row
          class="fondoDolar"
          style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px;"
        >
          <b-form-group label label-for="montoNetoExenta" class="col-md mb-0">
            <b-form-input
            v-on:keypress="validarNumero($event)"
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="montoNetoExenta"
              type="number"
              name="montoNetoExenta"
              v-model="$v.form.montoNetoExenta.$model"
              :state="validateState('montoNetoExenta')"
              aria-describedby="montoNetoExenta-mensaje-validacion"
              placeholder="Monto Comisión Exenta"
            ></b-form-input>
            <b-form-invalid-feedback id="montoNetoExenta-mensaje-validacion"
              >El Monto Neto Exenta es obligatorio, sin puntos ni comas.</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label label-for="ivaExenta" class="col-md mb-0">
            <b-form-input
            v-on:keypress="validarNumero($event)"
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="ivaExenta"
              type="number"
              name="ivaExenta"
              v-model="$v.form.ivaExenta.$model"
              :state="validateState('ivaExenta')"
              aria-describedby="ivaExenta-mensaje-validacion"
              placeholder="Impuesto Exenta"
            ></b-form-input>
            <b-form-invalid-feedback id="ivaExenta-mensaje-validacion"
              >El Iva es obligatorio, sin puntos ni comas.</b-form-invalid-feedback
            >
          </b-form-group>
          <b-form-group label label-for="montoTotalExenta" class="col-md mb-0">
            <b-form-input
            v-on:keypress="validarNumero($event)"
              class="form-control h-auto py-4 px-6 bordeFormulario"
              id="montoTotalExenta"
              type="number"
              name="montoTotalExenta"
              v-model="$v.form.montoTotalExenta.$model"
              :state="validateState('montoTotalExenta')"
              aria-describedby="montoTotalExenta-mensaje-validacion"
              placeholder="Monto Total Exenta"
            ></b-form-input>
            <b-form-invalid-feedback id="montoTotalExenta-mensaje-validacion"
              >El Monto Total obligatorio, sin puntos ni comas.</b-form-invalid-feedback
            >
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group class="mb-3 col" label label-for="boletaFacturaExenta">
            <b-form-file
              name="boletaFacturaExenta_1"
              id="boletaFacturaExenta_1"
              :placeholder="mesajeFacturaExenta  == true ? 'Adjuntar Boleta o Factura en formato PDF' : 'Adjuntar Nota de crédito en formato PDF'"
              accept=".pdf"
              @change="cargarArchivosExenta($event, item)"
            ></b-form-file>
            <!-- <div
            class="alert alert-custom mensaje-exstension-permitida alert-notice alert-light-primary fade show mt-2"
            role="alert"
          >
            <div class="alert-text font-size-sm">
              El documento debe ser
              <strong>pdf</strong>
            </div>
          </div> -->
            <!-- <div class="mt-1  font-size-2" > </div> -->
          </b-form-group>
        </b-row>
      </div>
      <!--INPUTS EXENTA -->
      <div class="d-flex flex-wrap flex-center">
        <button
          v-show="this.esNegativo == false"
          type="submit"
          ref="btn_archivos"
          class="btn  btn-contempora font-weight-bold p-4 pl-8 pr-8"
        >
          Enviar Documento
        </button>
      </div>
    </b-form>
    <div
      id="mensajeNegativo"
      style="text-align: center;"
      class="alert alert-custom alert-notice alert-light-success fade show p-2"
      v-show="this.esNegativo == true"
    >
      <h5 class="col-xl-12 ajusteTexto" style="margin-bottom: 0px !important;">
        <strong
          >Estimad@, el saldo negativo será descontado en la próxima
          liquidación.</strong
        >
      </h5>
    </div>
  </div>
</template>

<style>
.spinner.spinner-right:before {
  right: 0.3rem !important;
}
.mensaje-exstension-permitida {
  padding: 5px 10px !important;
  border-radius: 0 !important;
}

.collapse-documentos {
}

.collapse-botton {
  background: #ffffff !important;
  border: 0;
  text-align: left;
}
</style>
<script>
import moment from "moment";
import { validationMixin } from "vuelidate";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { SUBIR_ARCHIVO_BOLETA_FACTURA,GET_PERMITIR_SUBIR_DOCUMENTOS } from "@/core/services/store/liquidacion.module";
import {
  email,
  minLength,
  maxLength,
  required,
  integer
} from "vuelidate/lib/validators";

const requiredTipoDocumento = (value, tipoDocumento) => {
  if (value=='' && tipoDocumento != 'BOLETA') {
    return false
  } else {
    return true
  }
}


export default {
  mixins: [validationMixin],
  name: "detalleComision",
  props: ["comision", "retenciones"],
  data() {
    return {
      subirDocumentos: {
        permitir:true,
        inicio:0,
        fin:0
      },
      mesajeFacturaAfecta: true,
      mesajeFacturaExenta: true,
      listaRetenciones: null,
      valorRetencion: null,
      retencionOpcional: false,
      esRetencionOpcional: false,
      mensaje: {
        mostrar: false,

        titulo: "",
        mensajes: [],
        tipoMensaje: "",
      },
      tipoCambioUF: false,
      tipoCambioUS: false,
      tipoCambioUTM: false,
      tipoCambioEUR: false,
      tipoCambioDA: false,
      tipoCambioASB: false,
      existeAfecta: false,
      existeExenta: false,
      existeAfectaUF: false,
      existeAfectaUS: false,
      existeAfectaUTM: false,
      existeAfectaEUR: false,
      existeAfectaDA : false,
      existeAfectaASB : false,
      existeExentaUF: false,
      existeExentaUS: false,
      existeExentaUTM: false,
      existeExentaEUR: false,
      existeExentaDA: false,
      existeExentaASB: false,
      esNegativo: false,
      enviarDocumento: {},
      archivosCargadosParaEnviar: [],
      documento: {
        afecta: null,
        exenta: null,
      },
      formVualidate: false,
      form: {
        numeroDocumento:null,
        numeroDocumentoExenta: null,
        montoNetoAfecta: null,
        ivaAfecta: null,
        montoTotalAfecta: null,
        montoNetoExenta: null,
        ivaExenta: null,
        montoTotalExenta: null,
        fechaFacturacionBoleta: null,
        fechaFacturacionBoletaExenta: null,
        // rutCorredor: null,
        // mes: null,
        // anio: null,
      },
      comisionesUf: {
        tipoCambio: 0,
        tipoDocumento:'',
        afecta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          afectoNeto: 0,
          montoAfectaUF:0
        },
        exenta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          exentoNeto: 0,
          montoExentaUF:0
        },
        total: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          totalAfecta: 0,
          netoTotalAfecta: 0,
          impuestoTotalAfecta: 0,
          totalExenta: 0,
          netoTotalExenta: 0,
          impuestoTotalExenta: 0,
        },
      },
      comisionesDolar: {
        tipoCambio: 0,
        afecta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          afectoNeto: 0,
          montoAfectaUF:0
        },
        exenta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          exentoNeto: 0,
          montoExentaUF:0
        },
        total: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          totalAfectoClp: 0,
          totalAfecta: 0,
          netoTotalAfecta: 0,
          impuestoTotalAfecta: 0,
          totalExenta: 0,
          netoTotalExenta: 0,
          impuestoTotalExenta: 0,
        },
      },

      comisionesUTM: {
        tipoCambio: 0,
        afecta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          afectoNeto: 0,
        },
        exenta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          exentoNeto: 0,
        },
        total: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          totalAfectoClp: 0,
          totalAfecta: 0,
          netoTotalAfecta: 0,
          impuestoTotalAfecta: 0,
          totalExenta: 0,
          netoTotalExenta: 0,
          impuestoTotalExenta: 0,
        },
      },
      comisionesEuro: {
        tipoCambio: 0,
        afecta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          afectoNeto: 0,
          montoAfectaUF:0
        },
        exenta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          exentoNeto: 0,
          montoExentaUF:0
        },
        total: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          totalAfectoClp: 0,
          totalAfecta: 0,
          netoTotalAfecta: 0,
          impuestoTotalAfecta: 0,
          totalExenta: 0,
          netoTotalExenta: 0,
          impuestoTotalExenta: 0,
        },
      },
      comisionesDA: {
        tipoCambio: 0,
        afecta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          afectoNeto: 0,
          montoAfectaUF:0
        },
        exenta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          exentoNeto: 0,
           montoExentaUF:0
        },
        total: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          totalAfectoClp: 0,
          totalAfecta: 0,
          netoTotalAfecta: 0,
          impuestoTotalAfecta: 0,
          totalExenta: 0,
          netoTotalExenta: 0,
          impuestoTotalExenta: 0,
        },
      },
      comisionesASB: {
        tipoCambio: 0,
        afecta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          afectoNeto: 0,
          montoAfectaUF:0
        },
        exenta: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          exentoNeto: 0,
           montoExentaUF:0
        },
        total: {
          montoComision: 0,
          montoNetoClp: 0,
          impuestoClp: 0,
          totalAfectoClp: 0,
          totalAfecta: 0,
          netoTotalAfecta: 0,
          impuestoTotalAfecta: 0,
          totalExenta: 0,
          netoTotalExenta: 0,
          impuestoTotalExenta: 0,
        },
      }
    };
  },
  validations() {
    if (this.existeAfecta && this.existeExenta) {
      return {
        form: {
          numeroDocumento: {
            required,
            minLength: minLength(3),
          },

          numeroDocumentoExenta: {
            requiredTipoDocumento(value) {          
          return requiredTipoDocumento(value, this.tipoDocumento)          
        },
            minLength: minLength(3),
          },
          montoNetoAfecta: {
            required,
            minLength: minLength(1),
            integer
          },
          ivaAfecta: {
            required,
            minLength: minLength(1),
            integer
          },
          montoTotalAfecta: {
            required,
            minLength: minLength(1),
            integer
          },
          montoNetoExenta: {
            requiredTipoDocumento(value) {        
          return requiredTipoDocumento(value, this.tipoDocumento)          
        },
            minLength: minLength(1),
            integer
          },
          ivaExenta: {
            requiredTipoDocumento(value) {          
          return requiredTipoDocumento(value, this.tipoDocumento)          
        },
            minLength: minLength(1),
            integer
          },
          montoTotalExenta: {
            requiredTipoDocumento(value) {          
          return requiredTipoDocumento(value, this.tipoDocumento)          
        },
            minLength: minLength(1),
            integer
          },
          fechaFacturacionBoleta: {
            required,
            // minLength: minLength(10),
            // minLength: maxLength(10),
          },
          fechaFacturacionBoletaExenta: {
            requiredTipoDocumento(value) {          
          return requiredTipoDocumento(value, this.tipoDocumento)          
        },
            // minLength: minLength(10),
            // minLength: maxLength(10),
          },
        },
      };
    } else if (this.existeAfecta && this.existeExenta == false) {
      return {
        form: {
          numeroDocumento: {
            required,
            minLength: minLength(3),
          },

          numeroDocumentoExenta: {
            minLength: minLength(0),
          },
          montoNetoAfecta: {
            required,
            minLength: minLength(1),
            integer
          },
          ivaAfecta: {
            required,
            minLength: minLength(1),
            integer
          },
          montoTotalAfecta: {
            required,
            minLength: minLength(1),
            integer
          },
          montoNetoExenta: {
            minLength: minLength(0),
            integer
          },
          ivaExenta: {
            minLength: minLength(0),
            integer
          },
          montoTotalExenta: {
            minLength: minLength(0),
            integer
          },
          fechaFacturacionBoleta: {
            required,
            // minLength: minLength(10),
            // minLength: maxLength(10),
          },
          fechaFacturacionBoletaExenta: {
            // minLength: minLength(10),
            // minLength: maxLength(10),
          },
          // rutCorredor: {
          //   required,
          // },
          //  mes: {
          //   required,
          // },
          //  anio: {
          //   required,
          // 
        },
      };
    } else if (this.existeExenta && this.existeAfecta == false) {
      return {
        form: {
          numeroDocumento: {
            minLength: minLength(3),
          },
          numeroDocumentoExenta: {
            required,
            minLength: minLength(3),
          },
          montoNetoAfecta: {
            minLength: minLength(1),
            integer
          },
          ivaAfecta: {
            minLength: minLength(1),
            integer
          },
          montoTotalAfecta: {
            minLength: minLength(1),
            integer
          },
          montoNetoExenta: {
            minLength: minLength(1),
            integer
          },
          ivaExenta: {
            minLength: minLength(1),
            integer
          },
          montoTotalExenta: {
            minLength: minLength(1),
            integer
          },
          fechaFacturacionBoleta: {
            // minLength: minLength(10),
            // minLength: maxLength(10),
          },
          fechaFacturacionBoletaExenta: {
           // required,
            // minLength: minLength(10),
            // minLength: maxLength(10),
          },
          // rutCorredor: {
          //   required,
          // },
          //  mes: {
          //   required,
          // },
          //  anio: {
          //   required,
          // },
        },
      };
    }
  },
 beforeMount: function() {
    this.existeAfecta = false;
    this.existeExenta = false;
    this.mesajeFacturaAfecta = false
    this.mesajeFacturaExenta = false
    this.comision.forEach((element) => {
      
      if (element.esAfecta && element.totalAfecta > 0) {
        this.existeAfecta = true;
        this.mesajeFacturaAfecta = true
      }
      if (element.esExenta && element.totalExenta > 0) {
        this.existeExenta = true;
        this.mesajeFacturaExenta = true
      }
    });
  },
  mounted() {
    //console.log(this.comision)
    this.iniciarMontos();
    this.permitirSubirDocumentos();
  },
  methods: {
    permitirSubirDocumentos(){
    this.$store
          .dispatch(GET_PERMITIR_SUBIR_DOCUMENTOS)
          .then((resultado) => {
            this.subirDocumentos = resultado
          })
    },
    validarNumero(numero) {
      // let char = String.fromCharCode(numero.keyCode);
      // if (/^[0-9]+$/.test(char)) return true;
      // else numero.preventDefault();
    },
    iniciarMontos() {
      this.listaRetenciones = this.retenciones.filter((retencion) => {
        return (
          retencion.activo == true
        );
      });
      this.listaRetenciones.forEach((element) => {
        if (element.descripcion == "FIJO") {
          this.valorRetencion = element.valor;
        }
      });
      this.comisionesUf.total.totalAfecta = 0;
      this.comisionesUf.total.netoTotalAfecta = 0;
      this.comisionesUf.total.impuestoTotalAfecta = 0;
      this.comisionesDolar.total.totalExenta = 0;
      this.comisionesDolar.total.netoTotalExenta = 0;
      this.comisionesDolar.total.impuestoTotalExenta = 0;
      this.comisionesUTM.total.totalExenta = 0;
      this.comisionesUTM.total.netoTotalExenta = 0;
      this.comisionesUTM.total.impuestoTotalExenta = 0;
      this.comisionesEuro.total.totalExenta = 0;
      this.comisionesEuro.total.netoTotalExenta = 0;
      this.comisionesEuro.total.impuestoTotalExenta = 0;

      this.comision.forEach((comision) => {
        if (comision.moneda == "UF") {
          this.comisionesUf.tipoDocumento = comision.tipoDocumento;
          this.tipoCambioUF = true;
          if (comision.montoAfectaUF != 0) {
            this.existeAfecta = true;
            this.existeAfectaUF = true;
            this.comisionesUf.tipoCambio = comision.tipoCambio;
            this.comisionesUf.afecta.montoComision =
              comision.montoComisionAfecta;
            this.comisionesUf.afecta.montoNetoClp = comision.afectoNeto;
            this.comisionesUf.afecta.impuestoClp = comision.impuestoAfecta;
            this.comisionesUf.afecta.montoAfectaUF = comision.montoAfectaUF;

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;
              this.comisionesUf.afecta.afectoNeto =
                comision.afectoNeto - comision.impuestoAfecta;
            } else {
              this.comisionesUf.afecta.afectoNeto =
                comision.afectoNeto + comision.impuestoAfecta;
            }

            this.comisionesUf.total.totalAfecta = comision.totalAfecta;
            this.comisionesUf.total.netoTotalAfecta = comision.neto;
            this.comisionesUf.total.impuestoTotalAfecta =
              comision.impuestoTotal;
          }

          if (comision.montoExentaUF != 0) {
            this.existeExenta = true;
            this.existeExentaUF = true;
            this.comisionesUf.tipoCambio = comision.tipoCambio;
            this.comisionesUf.exenta.montoComision =
              comision.montoComisionExenta;
            this.comisionesUf.exenta.montoNetoClp = comision.exentoNeto;
            this.comisionesUf.exenta.impuestoClp = comision.impuestoExenta;
            this.comisionesUf.exenta.montoExentaUF = comision.montoExentaUF

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;

              this.comisionesUf.exenta.exentoNeto =
                comision.exentoNeto - comision.impuestoExenta;
            } else {
              this.comisionesUf.exenta.exentoNeto =
                comision.exentoNeto + comision.impuestoExenta;
            }

            this.comisionesUf.total.totalExenta = comision.totalExenta;
            this.comisionesUf.total.netoTotalExenta = comision.neto;
            this.comisionesUf.total.impuestoTotalExenta =
              comision.impuestoTotal;
          }

          this.comisionesUf.total.montoComision =
            this.comisionesUf.afecta.montoComision +
            this.comisionesUf.exenta.montoComision;
          this.comisionesUf.total.montoNetoClp =
            this.comisionesUf.afecta.montoNetoClp +
            this.comisionesUf.exenta.montoNetoClp;
          this.comisionesUf.total.impuestoClp =
            this.comisionesUf.afecta.impuestoClp +
            this.comisionesUf.exenta.impuestoClp;
          this.comisionesUf.total.totalAfectoClp =
            this.comisionesUf.afecta.totalAfectoClp +
            this.comisionesUf.exenta.totalAfectoClp;
        }
        if (comision.moneda == "US$") {
          this.tipoCambioUS = true;
          this.comisionesDolar.tipoDocumento = comision.tipoDocumento;
          if (comision.montoAfectaUF != 0) {
            this.existeAfecta = true;
            this.existeAfectaUS = true;
            this.comisionesDolar.tipoCambio = comision.tipoCambio;
            this.comisionesDolar.afecta.montoComision =
              comision.montoComisionAfecta;
            this.comisionesDolar.afecta.montoNetoClp = comision.afectoNeto;
            this.comisionesDolar.afecta.impuestoClp = comision.impuestoAfecta;
            this.comisionesDolar.afecta.montoAfectaUF = comision.montoAfectaUF;

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;

              this.comisionesDolar.afecta.afectoNeto =
                comision.afectoNeto - comision.impuestoAfecta;
            } else {
              this.comisionesDolar.afecta.afectoNeto =
                comision.afectoNeto + comision.impuestoAfecta;
            }

            this.comisionesUf.total.totalAfecta = comision.totalAfecta;
            this.comisionesUf.total.netoTotalAfecta = comision.neto;
            this.comisionesUf.total.impuestoTotalAfecta =
              comision.impuestoTotal;
          }

          if (comision.montoExentaUF != 0) {
            this.existeExenta = true;
            this.existeExentaUS = true;
            this.comisionesDolar.tipoCambio = comision.tipoCambio;
            this.comisionesDolar.exenta.montoComision =
              comision.montoComisionExenta;
            this.comisionesDolar.exenta.montoNetoClp = comision.exentoNeto;
            this.comisionesDolar.exenta.impuestoClp = comision.impuestoExenta;
            this.comisionesDolar.exenta.montoExentaUF = comision.montoExentaUF;
            
            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;

              this.comisionesDolar.exenta.exentoNeto =
                comision.exentoNeto - comision.impuestoExenta;
            } else {
              this.comisionesDolar.exenta.exentoNeto =
                comision.exentoNeto + comision.impuestoExenta;
            }

            this.comisionesUf.total.totalExenta = comision.totalExenta;
            this.comisionesUf.total.netoTotalExenta = comision.neto;
            this.comisionesUf.total.impuestoTotalExenta =
              comision.impuestoTotal;
          }

          this.comisionesDolar.total.montoComision =
            this.comisionesDolar.afecta.montoComision +
            this.comisionesDolar.exenta.montoComision;
          this.comisionesDolar.total.montoNetoClp =
            this.comisionesDolar.afecta.montoNetoClp +
            this.comisionesDolar.exenta.montoNetoClp;
          this.comisionesDolar.total.impuestoClp =
            this.comisionesDolar.afecta.impuestoClp +
            this.comisionesDolar.exenta.impuestoClp;
          this.comisionesDolar.total.totalAfectoClp =
            this.comisionesDolar.afecta.totalAfectoClp +
            this.comisionesDolar.exenta.totalAfectoClp;
        }
        if (comision.moneda == "UTM") {
          this.tipoCambioUTM = true;
          this.comisionesUTM.tipoDocumento = comision.tipoDocumento;
          if (comision.montoAfectaUF != 0) {
            this.existeAfecta = true;
            this.existeAfectaUTM = true;
            this.comisionesUTM.tipoCambio = comision.tipoCambio;
            this.comisionesUTM.afecta.montoComision =
              comision.montoComisionAfecta;
            this.comisionesUTM.afecta.montoNetoClp = comision.afectoNeto;
            this.comisionesUTM.afecta.impuestoClp = comision.impuestoAfecta;

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;

              this.comisionesUTM.afecta.afectoNeto =
                comision.afectoNeto - comision.impuestoAfecta;
            } else {
              this.comisionesUTM.afecta.afectoNeto =
                comision.afectoNeto + comision.impuestoAfecta;
            }

            this.comisionesUf.total.totalAfecta = comision.totalAfecta;
            this.comisionesUf.total.netoTotalAfecta = comision.neto;
            this.comisionesUf.total.impuestoTotalAfecta =
              comision.impuestoTotal;
          }

          if (comision.montoExentaUF != 0) {
            this.existeExenta = true;
            this.existeExentaUTM = true;
            this.comisionesUTM.tipoCambio = comision.tipoCambio;
            this.comisionesUTM.exenta.montoComision =
              comision.montoComisionExenta;
            this.comisionesUTM.exenta.montoNetoClp = comision.exentoNeto;
            this.comisionesUTM.exenta.impuestoClp = comision.impuestoExenta;

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;

              this.comisionesUTM.exenta.exentoNeto =
                comision.exentoNeto - comision.impuestoExenta;
            } else {
              this.comisionesUTM.exenta.exentoNeto =
                comision.exentoNeto + comision.impuestoExenta;
            }

            this.comisionesUf.total.totalExenta = comision.totalExenta;
            this.comisionesUf.total.netoTotalExenta = comision.neto;
            this.comisionesUf.total.impuestoTotalExenta =
              comision.impuestoTotal;
          }

          this.comisionesUTM.total.montoComision =
            this.comisionesUTM.afecta.montoComision +
            this.comisionesUTM.exenta.montoComision;
          this.comisionesUTM.total.montoNetoClp =
            this.comisionesUTM.afecta.montoNetoClp +
            this.comisionesUTM.exenta.montoNetoClp;
          this.comisionesUTM.total.impuestoClp =
            this.comisionesUTM.afecta.impuestoClp +
            this.comisionesUTM.exenta.impuestoClp;
          this.comisionesUTM.total.totalAfectoClp =
            this.comisionesUTM.afecta.totalAfectoClp +
            this.comisionesUTM.exenta.totalAfectoClp;
        }
        if (comision.moneda == "EUR") {
          this.tipoCambioEUR = true;
          this.comisionesEuro.tipoDocumento = comision.tipoDocumento;
          if (comision.montoAfectaUF != 0) {
            this.existeAfecta = true;
            this.existeAfectaEUR = true;
            this.comisionesEuro.tipoCambio = comision.tipoCambio;
            this.comisionesEuro.afecta.montoComision =
              comision.montoComisionAfecta;
            this.comisionesEuro.afecta.montoNetoClp = comision.afectoNeto;
            this.comisionesEuro.afecta.impuestoClp = comision.impuestoAfecta;
            this.comisionesEuro.afecta.montoAfectaUF = comision.montoAfectaUF;

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;

              this.comisionesEuro.afecta.afectoNeto =
                comision.afectoNeto - comision.impuestoAfecta;
            } else {
              this.comisionesEuro.afecta.afectoNeto =
                comision.afectoNeto + comision.impuestoAfecta;
            }

            this.comisionesUf.total.totalAfecta = comision.totalAfecta;
            this.comisionesUf.total.netoTotalAfecta = comision.neto;
            this.comisionesUf.total.impuestoTotalAfecta =
              comision.impuestoTotal;
          }

          if (comision.montoExentaUF != 0) {
            this.existeExenta = true;
            this.existeExentaEUR = true;
            this.comisionesEuro.tipoCambio = comision.tipoCambio;
            this.comisionesEuro.exenta.montoComision =
              comision.montoComisionExenta;
            this.comisionesEuro.exenta.montoNetoClp = comision.exentoNeto;
            this.comisionesEuro.exenta.impuestoClp = comision.impuestoExenta;
            this.comisionesEuro.exenta.montoExentaUF = comision.montoExentaUF;

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;

              this.comisionesEuro.exenta.exentoNeto =
                comision.exentoNeto - comision.impuestoExenta;
            } else {
              this.comisionesEuro.exenta.exentoNeto =
                comision.exentoNeto + comision.impuestoExenta;
            }

            this.comisionesUf.total.totalExenta = comision.totalExenta;
            this.comisionesUf.total.netoTotalExenta = comision.neto;
            this.comisionesUf.total.impuestoTotalExenta =
              comision.impuestoTotal;
          }

          this.comisionesEuro.total.montoComision =
            this.comisionesEuro.afecta.montoComision +
            this.comisionesEuro.exenta.montoComision;
          this.comisionesEuro.total.montoNetoClp =
            this.comisionesEuro.afecta.montoNetoClp +
            this.comisionesEuro.exenta.montoNetoClp;
          this.comisionesEuro.total.impuestoClp =
            this.comisionesEuro.afecta.impuestoClp +
            this.comisionesEuro.exenta.impuestoClp;
          this.comisionesEuro.total.totalAfectoClp =
            this.comisionesEuro.afecta.totalAfectoClp +
            this.comisionesEuro.exenta.totalAfectoClp;
        }
        if (comision.moneda == "DA") {
          this.tipoCambioDA = true;
          this.comisionesDA.tipoDocumento = comision.tipoDocumento;
          if (comision.montoAfectaUF != 0) {
            this.existeAfecta = true;
            this.existeAfectaDA = true;
            this.comisionesDA.tipoCambio = comision.tipoCambio;
            this.comisionesDA.afecta.montoComision = comision.montoComisionAfecta;
            this.comisionesDA.afecta.montoNetoClp = comision.afectoNeto;
            this.comisionesDA.afecta.impuestoClp = comision.impuestoAfecta;
            this.comisionesDA.afecta.montoAfectaUF = comision.montoAfectaUF;

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;
              this.comisionesDA.afecta.afectoNeto = comision.afectoNeto - comision.impuestoAfecta;
            } else {
              this.comisionesDA.afecta.afectoNeto = comision.afectoNeto + comision.impuestoAfecta;
            }

            this.comisionesUf.total.totalAfecta = comision.totalAfecta;
            this.comisionesUf.total.netoTotalAfecta = comision.neto;
            this.comisionesUf.total.impuestoTotalAfecta = comision.impuestoTotal;
          }

          if (comision.montoExentaUF != 0) {
            this.existeExenta = true;
            this.existeExentaDA = true;
            this.comisionesDA.tipoCambio = comision.tipoCambio;
            this.comisionesDA.exenta.montoComision = comision.montoComisionExenta;
            this.comisionesDA.exenta.montoNetoClp = comision.exentoNeto;
            this.comisionesDA.exenta.impuestoClp = comision.impuestoExenta;
            this.comisionesDA.exenta.montoExentaUF = comision.montoExentaUF;

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;
              this.comisionesDA.exenta.exentoNeto = comision.exentoNeto - comision.impuestoExenta;
            } else {
              this.comisionesDA.exenta.exentoNeto = comision.exentoNeto + comision.impuestoExenta;
            }
            this.comisionesUf.total.totalExenta = comision.totalExenta;
            this.comisionesUf.total.netoTotalExenta = comision.neto;
            this.comisionesUf.total.impuestoTotalExenta = comision.impuestoTotal;
          }

          this.comisionesDA.total.montoComision = this.comisionesDA.afecta.montoComision + this.comisionesDA.exenta.montoComision;
          this.comisionesDA.total.montoNetoClp = this.comisionesDA.afecta.montoNetoClp + this.comisionesDA.exenta.montoNetoClp;
          this.comisionesDA.total.impuestoClp = this.comisionesDA.afecta.impuestoClp + this.comisionesDA.exenta.impuestoClp;
          this.comisionesDA.total.totalAfectoClp = this.comisionesDA.afecta.totalAfectoClp + this.comisionesDA.exenta.totalAfectoClp;
        }
        if (comision.moneda == "ASB") {
          this.tipoCambioASB = true;
          this.comisionesASB.tipoDocumento = comision.tipoDocumento;
          if (comision.montoAfectaUF != 0) {
            this.existeAfecta = true;
            this.existeAfectaASB = true;
            this.comisionesASB.tipoCambio = comision.tipoCambio;
            this.comisionesASB.afecta.montoComision = comision.montoComisionAfecta;
            this.comisionesASB.afecta.montoNetoClp = comision.afectoNeto;
            this.comisionesASB.afecta.impuestoClp = comision.impuestoAfecta;
            this.comisionesASB.afecta.montoAfectaUF = comision.montoAfectaUF;

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;
              this.comisionesASB.afecta.afectoNeto = comision.afectoNeto - comision.impuestoAfecta;
            } else {
              this.comisionesASB.afecta.afectoNeto = comision.afectoNeto + comision.impuestoAfecta;
            }

            this.comisionesUf.total.totalAfecta = comision.totalAfecta;
            this.comisionesUf.total.netoTotalAfecta = comision.neto;
            this.comisionesUf.total.impuestoTotalAfecta = comision.impuestoTotal;
          }

          if (comision.montoExentaUF != 0) {
            this.existeExenta = true;
            this.existeExentaASB = true;
            this.comisionesASB.tipoCambio = comision.tipoCambio;
            this.comisionesASB.exenta.montoComision = comision.montoComisionExenta;
            this.comisionesASB.exenta.montoNetoClp = comision.exentoNeto;
            this.comisionesASB.exenta.impuestoClp = comision.impuestoExenta;
            this.comisionesASB.exenta.montoExentaUF = comision.montoExentaUF;

            if (comision.tipoDocumento == "BOLETA") {
              this.retencionOpcional = true;
              this.comisionesASB.exenta.exentoNeto = comision.exentoNeto - comision.impuestoExenta;
            } else {
              this.comisionesASB.exenta.exentoNeto = comision.exentoNeto + comision.impuestoExenta;
            }
            this.comisionesUf.total.totalExenta = comision.totalExenta;
            this.comisionesUf.total.netoTotalExenta = comision.neto;
            this.comisionesUf.total.impuestoTotalExenta = comision.impuestoTotal;
          }

          this.comisionesDA.total.montoComision = this.comisionesDA.afecta.montoComision + this.comisionesDA.exenta.montoComision;
          this.comisionesDA.total.montoNetoClp = this.comisionesDA.afecta.montoNetoClp + this.comisionesDA.exenta.montoNetoClp;
          this.comisionesDA.total.impuestoClp = this.comisionesDA.afecta.impuestoClp + this.comisionesDA.exenta.impuestoClp;
          this.comisionesDA.total.totalAfectoClp = this.comisionesDA.afecta.totalAfectoClp + this.comisionesDA.exenta.totalAfectoClp;
        } 
      });

      var sumatoriaAfectaExenta =
        this.comisionesUf.total.totalAfecta +
        this.comisionesUf.total.totalExenta;

      if (sumatoriaAfectaExenta >= 0) {
        if(document.getElementById("mensajeNegativo") != null)
        {
          document.getElementById("mensajeNegativo").remove();
        }
        
        if (this.tipoCambioUF == false) {
          let uf = document.getElementsByClassName("tipoCambioUF");
          uf.forEach((uf) => {
            uf.remove();
          });
        }
        if (this.tipoCambioUS == false) {
          let us = document.getElementsByClassName("tipoCambioUS");
          us.forEach((us) => {
            us.remove();
          });
        }
        if (this.tipoCambioUTM == false) {
          let utm = document.getElementsByClassName("tipoCambioUTM");
          utm.forEach((utm) => {
            utm.remove();
          });
        }
        if (this.tipoCambioEUR == false) {
          let eur = document.getElementsByClassName("tipoCambioEUR");
          eur.forEach((eur) => {
            eur.remove();
          });
        }
        if (this.existeAfecta == false) {
          let afecta = document.getElementsByClassName("existeAfecta");
          afecta.forEach((afecta) => {
            afecta.remove();
          });
        }
        if (this.existeExenta == false) {
          let exenta = document.getElementsByClassName("existeExenta");
          exenta.forEach((exenta) => {
            exenta.remove();
          });
        }
      } else {
        this.esNegativo = true;
        document.getElementById("formLiquidacion").remove();
      }
    },

    calcularImpuesto(item) {
      if (item.descripcion == "FIJO") {
        this.esRetencionOpcional = false;
        this.iniciarMontos();
      } else {
        this.esRetencionOpcional = true;
        this.comisionesUf.total.totalAfecta = 0;
        this.comisionesUf.total.netoTotalAfecta = 0;
        this.comisionesUf.total.impuestoTotalAfecta = 0;
        this.comisionesDolar.total.totalExenta = 0;
        this.comisionesDolar.total.netoTotalExenta = 0;
        this.comisionesDolar.total.impuestoTotalExenta = 0;
        this.comisionesUTM.total.totalExenta = 0;
        this.comisionesUTM.total.netoTotalExenta = 0;
        this.comisionesUTM.total.impuestoTotalExenta = 0;
        this.comisionesEuro.total.totalExenta = 0;
        this.comisionesEuro.total.netoTotalExenta = 0;
        this.comisionesEuro.total.impuestoTotalExenta = 0;
        this.comisionesUf.total.totalExenta = 0;
        this.comisionesUf.total.impuestoTotalAfecta = 0;
        this.comisionesUf.total.impuestoTotalExenta = 0;

        this.comision.forEach((comision) => {
          var nuevoValorImpuesto = null;
          if (comision.moneda == "UF") {
            this.tipoCambioUF = true;
            if (comision.montoAfectaUF != 0) {
              this.existeAfecta = true;
              this.existeAfectaUF = true;
              this.comisionesUf.tipoCambio = comision.tipoCambio;
              this.comisionesUf.afecta.montoComision =
                comision.montoComisionAfecta;
              this.comisionesUf.afecta.montoNetoClp = comision.afectoNeto;
              //nuevoValorImpuesto = (this.comisionesUf.afecta.montoNetoClp *(item.valor * 0.01) ).toString();
              nuevoValorImpuesto = (this.comisionesUf.afecta.montoNetoClp *(item.valor) ).toString();
              this.comisionesUf.afecta.impuestoClp = nuevoValorImpuesto.substring(
                0,
                nuevoValorImpuesto.indexOf(".")
              );

              if (comision.tipoDocumento == "BOLETA") {
                this.comisionesUf.afecta.afectoNeto =
                  parseInt(this.comisionesUf.afecta.montoNetoClp) -
                  parseInt(this.comisionesUf.afecta.impuestoClp);
              } else {
                this.comisionesUf.afecta.afectoNeto =
                  comision.afectoNeto + comision.impuestoAfecta;
              }

              this.comisionesUf.total.totalAfecta =
                this.comisionesUf.total.totalAfecta +
                (parseInt(this.comisionesUf.afecta.montoNetoClp) -
                  parseInt(this.comisionesUf.afecta.impuestoClp));
              this.comisionesUf.total.netoTotalAfecta = comision.neto;
              this.comisionesUf.total.impuestoTotalAfecta = nuevoValorImpuesto.substring(
                0,
                nuevoValorImpuesto.indexOf(".")
              );
            }

            if (comision.montoExentaUF != 0) {
              this.existeExenta = true;
              this.existeExentaUF = true;
              this.comisionesUf.tipoCambio = comision.tipoCambio;
              this.comisionesUf.exenta.montoComision =
                comision.montoComisionExenta;
              this.comisionesUf.exenta.montoNetoClp = comision.exentoNeto;
              nuevoValorImpuesto = (
                //this.comisionesUf.exenta.montoNetoClp * (item.valor * 0.01)).toString();
                this.comisionesUf.exenta.montoNetoClp * (item.valor)).toString();
              this.comisionesUf.exenta.impuestoClp = nuevoValorImpuesto.substring(
                0,
                nuevoValorImpuesto.indexOf(".")
              );

              if (comision.tipoDocumento == "BOLETA") {
                this.comisionesUf.exenta.exentoNeto =
                  parseInt(this.comisionesUf.exenta.montoNetoClp) -
                  parseInt(this.comisionesUf.exenta.impuestoClp);
              } else {
                this.comisionesUf.exenta.exentoNeto =
                  comision.exentoNeto + comision.impuestoExenta;
              }

              this.comisionesUf.total.totalExenta =
                this.comisionesUf.total.totalExenta +
                (parseInt(this.comisionesUf.exenta.montoNetoClp) -
                  parseInt(this.comisionesUf.exenta.impuestoClp));
              this.comisionesUf.total.netoTotalExenta = comision.neto;
              this.comisionesUf.total.impuestoTotalExenta = nuevoValorImpuesto.substring(
                0,
                nuevoValorImpuesto.indexOf(".")
              );
            }

            this.comisionesUf.total.montoComision =
              this.comisionesUf.afecta.montoComision +
              this.comisionesUf.exenta.montoComision;
            this.comisionesUf.total.montoNetoClp =
              this.comisionesUf.afecta.montoNetoClp +
              this.comisionesUf.exenta.montoNetoClp;
            this.comisionesUf.total.impuestoClp =
              this.comisionesUf.afecta.impuestoClp +
              this.comisionesUf.exenta.impuestoClp;
            this.comisionesUf.total.totalAfectoClp =
              this.comisionesUf.afecta.totalAfectoClp +
              this.comisionesUf.exenta.totalAfectoClp;
          }

          if (comision.moneda == "US$") {
            this.tipoCambioUS = true;
            if (comision.montoAfectaUF != 0) {
              this.existeAfecta = true;
              this.existeAfectaUS = true;
              this.comisionesDolar.tipoCambio = comision.tipoCambio;
              this.comisionesDolar.afecta.montoComision =
                comision.montoComisionAfecta;
              nuevoValorImpuesto = (
//                this.comisionesDolar.afecta.montoNetoClp *(item.valor * 0.01)).toString();
                this.comisionesDolar.afecta.montoNetoClp *(item.valor)).toString();
              this.comisionesDolar.afecta.impuestoClp = nuevoValorImpuesto.substring(
                0,
                nuevoValorImpuesto.indexOf(".")
              );

              if (comision.tipoDocumento == "BOLETA") {
                this.comisionesDolar.afecta.afectoNeto =
                  parseInt(this.comisionesDolar.afecta.montoNetoClp) -
                  parseInt(this.comisionesDolar.afecta.impuestoClp);
              } else {
                this.comisionesDolar.afecta.afectoNeto =
                  comision.afectoNeto + comision.impuestoAfecta;
              }

              this.comisionesUf.total.totalAfecta =
                this.comisionesUf.total.totalAfecta +
                (parseInt(this.comisionesDolar.afecta.montoNetoClp) -
                  parseInt(this.comisionesDolar.afecta.impuestoClp));
              this.comisionesDolar.total.netoTotalAfecta = comision.neto;
              this.comisionesUf.total.impuestoTotalAfecta =
                parseInt(this.comisionesUf.total.impuestoTotalAfecta) +
                parseInt(this.comisionesDolar.afecta.impuestoClp);
            }

            if (comision.montoExentaUF != 0) {
              this.existeExenta = true;
              this.existeExentaUS = true;
              this.comisionesDolar.tipoCambio = comision.tipoCambio;
              this.comisionesDolar.exenta.montoComision =
                comision.montoComisionExenta;
              nuevoValorImpuesto = (
                //this.comisionesDolar.exenta.montoNetoClp * (item.valor * 0.01)).toString();
                this.comisionesDolar.exenta.montoNetoClp * (item.valor)).toString();
              this.comisionesDolar.exenta.impuestoClp = nuevoValorImpuesto.substring(
                0,
                nuevoValorImpuesto.indexOf(".")
              );
              if (comision.tipoDocumento == "BOLETA") {
                this.comisionesDolar.exenta.exentoNeto =
                  parseInt(this.comisionesDolar.exenta.montoNetoClp) -
                  parseInt(this.comisionesDolar.exenta.impuestoClp);
              } else {
                this.comisionesDolar.exenta.exentoNeto =
                  comision.exentoNeto + comision.impuestoExenta;
              }

              this.comisionesUf.total.totalExenta =
                this.comisionesUf.total.totalExenta +
                (parseInt(this.comisionesDolar.exenta.montoNetoClp) -
                  parseInt(this.comisionesDolar.exenta.impuestoClp));
              this.comisionesDolar.total.netoTotalExenta = comision.neto;
              this.comisionesUf.total.impuestoTotalExenta =
                parseInt(this.comisionesUf.total.impuestoTotalExenta) +
                parseInt(this.comisionesDolar.exenta.impuestoClp);
            }

            this.comisionesDolar.total.montoComision =
              this.comisionesDolar.afecta.montoComision +
              this.comisionesDolar.exenta.montoComision;
            this.comisionesDolar.total.montoNetoClp =
              this.comisionesDolar.afecta.montoNetoClp +
              this.comisionesDolar.exenta.montoNetoClp;
            this.comisionesDolar.total.impuestoClp =
              this.comisionesDolar.afecta.impuestoClp +
              this.comisionesDolar.exenta.impuestoClp;
            this.comisionesDolar.total.totalAfectoClp =
              this.comisionesDolar.afecta.totalAfectoClp +
              this.comisionesDolar.exenta.totalAfectoClp;
          }

          if (comision.moneda == "UTM") {
            this.tipoCambioUTM = true;
            if (comision.montoAfectaUF != 0) {
              this.existeAfecta = true;
              this.existeAfectaUTM = true;
              this.comisionesUTM.tipoCambio = comision.tipoCambio;
              this.comisionesUTM.afecta.montoComision =
                comision.montoComisionAfecta;
              //nuevoValorImpuesto = (this.comisionesUTM.afecta.montoNetoClp *(item.valor * 0.01)).toString();
              nuevoValorImpuesto = (this.comisionesUTM.afecta.montoNetoClp *(item.valor)).toString();

              this.comisionesUTM.afecta.impuestoClp = nuevoValorImpuesto.substring(
                0,
                nuevoValorImpuesto.indexOf(".")
              );

              if (comision.tipoDocumento == "BOLETA") {
                this.comisionesUTM.afecta.afectoNeto =
                  parseInt(this.comisionesUTM.afecta.montoNetoClp) -
                  parseInt(this.comisionesUTM.afecta.impuestoClp);
              } else {
                this.comisionesUTM.afecta.afectoNeto =
                  comision.afectoNeto + comision.impuestoAfecta;
              }

              this.comisionesUf.total.totalAfecta =
                this.comisionesUf.total.totalAfecta +
                (parseInt(this.comisionesUTM.afecta.montoNetoClp) -
                  parseInt(this.comisionesUTM.afecta.impuestoClp));
              this.comisionesUTM.total.netoTotalAfecta = comision.neto;
              this.comisionesUf.total.impuestoTotalAfecta =
                parseInt(this.comisionesUf.total.impuestoTotalAfecta) +
                parseInt(this.comisionesUTM.afecta.impuestoClp);
            }

            if (comision.montoExentaUF != 0) {
              this.existeExenta = true;
              this.existeExentaUTM = true;
              this.comisionesUTM.tipoCambio = comision.tipoCambio;
              this.comisionesUTM.exenta.montoComision =
                comision.montoComisionExenta;
              //nuevoValorImpuesto = (this.comisionesUTM.exenta.montoNetoClp *(item.valor * 0.01)).toString();
              nuevoValorImpuesto = (this.comisionesUTM.exenta.montoNetoClp *(item.valor)).toString();
              this.comisionesUTM.exenta.impuestoClp = nuevoValorImpuesto.substring(
                0,
                nuevoValorImpuesto.indexOf(".")
              );
              if (comision.tipoDocumento == "BOLETA") {
                this.comisionesUTM.exenta.exentoNeto =
                  parseInt(this.comisionesUTM.exenta.montoNetoClp) -
                  parseInt(this.comisionesUTM.exenta.impuestoClp);
              } else {
                this.comisionesUTM.exenta.exentoNeto =
                  comision.exentoNeto + comision.impuestoExenta;
              }

              this.comisionesUf.total.totalExenta =
                this.comisionesUf.total.totalExenta +
                (parseInt(this.comisionesUTM.exenta.montoNetoClp) -
                  parseInt(this.comisionesUTM.exenta.impuestoClp));
              this.comisionesUTM.total.netoTotalExenta = comision.neto;
              this.comisionesUf.total.impuestoTotalExenta =
                parseInt(this.comisionesUf.total.impuestoTotalExenta) +
                parseInt(this.comisionesUTM.exenta.impuestoClp);
            }

            this.comisionesUTM.total.montoComision =
              this.comisionesUTM.afecta.montoComision +
              this.comisionesUTM.exenta.montoComision;
            this.comisionesUTM.total.montoNetoClp =
              this.comisionesUTM.afecta.montoNetoClp +
              this.comisionesUTM.exenta.montoNetoClp;
            this.comisionesUTM.total.impuestoClp =
              this.comisionesUTM.afecta.impuestoClp +
              this.comisionesUTM.exenta.impuestoClp;
            this.comisionesUTM.total.totalAfectoClp =
              this.comisionesUTM.afecta.totalAfectoClp +
              this.comisionesUTM.exenta.totalAfectoClp;
          }

          if (comision.moneda == "EUR") {
            this.tipoCambioEUR = true;
            if (comision.montoAfectaUF != 0) {
              this.existeAfecta = true;
              this.existeAfectaEUR = true;
              this.comisionesEuro.tipoCambio = comision.tipoCambio;
              this.comisionesEuro.afecta.montoComision =
                comision.montoComisionAfecta;
              //nuevoValorImpuesto = (this.comisionesEuro.afecta.montoNetoClp * (item.valor * 0.01)).toString();
              nuevoValorImpuesto = (this.comisionesEuro.afecta.montoNetoClp * (item.valor)).toString();
              this.comisionesEuro.afecta.impuestoClp = nuevoValorImpuesto.substring(
                0,
                nuevoValorImpuesto.indexOf(".")
              );

              if (comision.tipoDocumento == "BOLETA") {
                this.comisionesEuro.afecta.afectoNeto =
                  parseInt(this.comisionesEuro.afecta.montoNetoClp) -
                  parseInt(this.comisionesEuro.afecta.impuestoClp);
              } else {
                this.comisionesEuro.afecta.afectoNeto =
                  comision.afectoNeto + comision.impuestoAfecta;
              }

              this.comisionesUf.total.totalAfecta =
                this.comisionesUf.total.totalAfecta +
                (parseInt(this.comisionesEuro.afecta.montoNetoClp) -
                  parseInt(this.comisionesEuro.afecta.impuestoClp));
              this.comisionesEuro.total.netoTotalAfecta = comision.neto;
              this.comisionesUf.total.impuestoTotalAfecta =
                parseInt(this.comisionesUf.total.impuestoTotalAfecta) +
                parseInt(this.comisionesEuro.afecta.impuestoClp);
            }

            if (comision.montoExentaUF != 0) {
              this.existeExenta = true;
              this.existeExentaEUR = true;
              this.comisionesEuro.tipoCambio = comision.tipoCambio;
              this.comisionesEuro.exenta.montoComision =
                comision.montoComisionExenta;
              //nuevoValorImpuesto = (this.comisionesEuro.exenta.montoNetoClp * (item.valor * 0.01)).toString();
              nuevoValorImpuesto = (this.comisionesEuro.exenta.montoNetoClp * (item.valor)).toString();
              this.comisionesEuro.exenta.impuestoClp = nuevoValorImpuesto.substring(
                0,
                nuevoValorImpuesto.indexOf(".")
              );
              if (comision.tipoDocumento == "BOLETA") {
                this.comisionesEuro.exenta.exentoNeto =
                  parseInt(this.comisionesEuro.exenta.montoNetoClp) -
                  parseInt(this.comisionesEuro.exenta.impuestoClp);
              } else {
                this.comisionesEuro.exenta.exentoNeto =
                  comision.exentoNeto + comision.impuestoExenta;
              }

              this.comisionesUf.total.totalExenta =
                this.comisionesUf.total.totalExenta +
                (parseInt(this.comisionesEuro.exenta.montoNetoClp) -
                  parseInt(this.comisionesEuro.exenta.impuestoClp));
              this.comisionesEuro.total.netoTotalExenta = comision.neto;
              this.comisionesUf.total.impuestoTotalExenta =
                parseInt(this.comisionesUf.total.impuestoTotalExenta) +
                parseInt(this.comisionesEuro.exenta.impuestoClp);
            }

            this.comisionesEuro.total.montoComision =
              this.comisionesEuro.afecta.montoComision +
              this.comisionesEuro.exenta.montoComision;
            this.comisionesEuro.total.montoNetoClp =
              this.comisionesEuro.afecta.montoNetoClp +
              this.comisionesEuro.exenta.montoNetoClp;
            this.comisionesEuro.total.impuestoClp =
              this.comisionesEuro.afecta.impuestoClp +
              this.comisionesEuro.exenta.impuestoClp;
            this.comisionesEuro.total.totalAfectoClp =
              this.comisionesEuro.afecta.totalAfectoClp +
              this.comisionesEuro.exenta.totalAfectoClp;
          }
        });

        var sumatoriaAfectaExenta =
          this.comisionesUf.total.totalAfecta +
          this.comisionesUf.total.totalExenta;
        if (sumatoriaAfectaExenta >= 0) {

          if(document.getElementById("mensajeNegativo") != null)
          {
            document.getElementById("mensajeNegativo").remove();
          }

          if (this.tipoCambioUF == false) {
            let uf = document.getElementsByClassName("tipoCambioUF");
            uf.forEach((uf) => {
              uf.remove();
            });
          }
          if (this.tipoCambioUS == false) {
            let us = document.getElementsByClassName("tipoCambioUS");
            us.forEach((us) => {
              us.remove();
            });
          }
          if (this.tipoCambioUTM == false) {
            let utm = document.getElementsByClassName("tipoCambioUTM");
            utm.forEach((utm) => {
              utm.remove();
            });
          }
          if (this.tipoCambioEUR == false) {
            let eur = document.getElementsByClassName("tipoCambioEUR");
            eur.forEach((eur) => {
              eur.remove();
            });
          }
          if (this.existeAfecta == false) {
            let afecta = document.getElementsByClassName("existeAfecta");
            afecta.forEach((afecta) => {
              afecta.remove();
            });
          }
          if (this.existeExenta == false) {
            let exenta = document.getElementsByClassName("existeExenta");
            exenta.forEach((exenta) => {
              exenta.remove();
            });
          }
        } else {
            this.esNegativo = true;
          document.getElementById("formLiquidacion").remove();
        }
      }
    },
    makeToast(append = false, texto, titulo, variant) {
      this.$bvToast.toast(texto, {
        title: titulo,
        autoHideDelay: 6000,
        variant: variant,
        toaster: "b-toaster-top-right",
        appendToast: append,
      });
    },
    formatoUF(moneda) {
      let monedaFormateada = moneda.toString().replace(".", ",");
      return monedaFormateada;
    },
    formatearPesos(moneda) {
      moneda = parseFloat(moneda)
        .toString()
        .replace(".", "")
        .replace(",", "");
      let monedaFormateada = new Intl.NumberFormat("es-CL", {
        style: "currency",
        currency: "CLP",
        minimumFractionDigits: 0,
      });
      let salida = monedaFormateada.format(moneda).replace("$", "");

      // let monedaFormateada = new Intl.NumberFormat("es-CL");
      // let salida = monedaFormateada.format(moneda);
      // salida = salida
      //   .toString()
      //   .replace(",", ".")
      //   .replace(",", ".");
      return salida;
    },
    formatearDolar(moneda) {
      let monedaFormateada = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits : 2
      });

      return monedaFormateada.format(moneda).replace("€", "");
    },
    formatearEuro(moneda) {
      let monedaFormateada = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits : 2
      });

      return monedaFormateada.format(moneda).replace("€", "");
    },
    formatearUF(moneda) {
      let monedaFormateada = new Intl.NumberFormat("de-DE", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 5,
      });

      return monedaFormateada.format(moneda).replace("€", "");
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    resetForm() {
      this.form = {
        numeroDocumento: null,
        numeroDocumentoExenta: null,
        montoNetoAfecta: null,
        ivaAfecta: null,
        montoTotalAfecta: null,
        montoNetoExenta: null,
        ivaExenta: null,
        montoTotalExenta: null,
        fechaFacturacionBoleta: null,
        fechaFacturacionBoletaExenta: null,
        // rutCorredor: null,
        // mes: null,
        // anio: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    obtenerTipoDocumentoActivo() {
      if (this.tipoCambioUF) return this.comisionesUf.tipoDocumento;
      if (this.tipoCambioUS) return this.comisionesDolar.tipoDocumento;
      if (this.tipoCambioUTM) return this.comisionesUTM.tipoDocumento;
      if (this.tipoCambioEUR) return this.comisionesEuro.tipoDocumento;
      if (this.tipoCambioDA) return this.comisionesDA.tipoDocumento;
      if (this.tipoCambioASB) return this.comisionesASB.tipoDocumento;
      return this.comisionesUf.tipoDocumento;
    },
    async cargarArchivos(archivo, item) {
      let archivoRef = archivo.target ? archivo.target.files[0] : archivo;
      if (!archivoRef) return;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {

          var extension = file.type;
          if(extension != 'application/pdf')
          {
            this.documento.afecta = null;
            document.getElementById("boletaFactura").value = null;

            this.makeToast(
              false,
              "Archivo debe ser PDF",
              "Aviso",
              "danger"
            );
            resolve(null);
            return;
          }
          else
          {
            const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          }       
        });

       
      this.documento.afecta = await toBase64(archivoRef);
    },
    async cargarArchivosExenta(archivo, item) {
      let archivoRef = archivo.target ? archivo.target.files[0] : archivo;
      if (!archivoRef) return;

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          var extension =file.type;
          
          if(extension != 'application/pdf')
          {
            this.documento.exenta = null;
            document.getElementById("boletaFacturaExenta").value = null;
           
            this.makeToast(
              false,
              "Archivo debe ser PDF",
              "Aviso",
              "danger"
            );
            resolve(null);
            return;
          }
          else
          {
            const reader = new FileReader();
           // alert("EXTENSION => " + file.type);
            reader.readAsDataURL(file);
            if(extension != 'application/pdf')
            {
              reader.onload = () => resolve(null);
              reader.onerror = (error) => reject(error);
            }
            else
            {
              reader.onload = () => resolve(reader.result);
              reader.onerror = (error) => reject(error);
            }   
          }        
        });

        this.documento.exenta = await toBase64(archivoRef);
    },
    async onSubmitformEnviarBoletaFactura() {
      var tolerancia = 5;
      this.mensaje.mostrar = false;
      this.$v.form.$touch();

      if (this.$v.form.$anyError) {
        return;
      }

      const submitButton = this.$refs["btn_archivos"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      let base64Afecta = this.documento.afecta || null;
      let base64Exenta = this.documento.exenta || null;

      let datos = {};      
      let comisiones = [];

      if(this.esRetencionOpcional)
        {        
          if(this.tipoCambioUF)
          {
            let unaComision = {
              moneda : "UF",
              impuestoTotalAfecta : parseInt(this.comisionesUf.total.impuestoTotalAfecta), 
              totalAfecta :this.comisionesUf.total.totalAfecta,
              impuestoTotalExenta: parseInt(this.comisionesUf.total.impuestoTotalExenta),
              totalExenta : parseInt(this.comisionesUf.total.totalExenta)
            };
            comisiones.push(unaComision);
          }
          if(this.tipoCambioUS)
          {
            let unaComision = {
              moneda : "US$",
              impuestoTotalAfecta :parseInt(this.comisionesDolar.total.impuestoTotalAfecta), 
              totalAfecta :this.comisionesDolar.total.totalAfecta,
              impuestoTotalExenta: parseInt(this.comisionesDolar.total.impuestoTotalExenta),
              totalExenta :parseInt( this.comisionesDolar.total.totalExenta)
            };
            comisiones.push(unaComision);
          }
          if(this.tipoCambioUTM)
          {
            let unaComision = {
              moneda : "UTM",
              impuestoTotalAfecta :parseInt(this.comisionesUTM.total.impuestoTotalAfecta), 
              totalAfecta :this.comisionesUTM.total.totalAfecta,
              impuestoTotalExenta: parseInt(this.comisionesUTM.total.impuestoTotalExenta),
              totalExenta : parseInt(this.comisionesUTM.total.totalExenta)
            };
            comisiones.push(unaComision);
          }
          if(this.tipoCambioEUR)
          {
            let unaComision = {
              moneda : "EUR",
              impuestoTotalAfecta : parseInt(this.comisionesEuro.total.impuestoTotalAfecta), 
              totalAfecta :this.comisionesEuro.total.totalAfecta,
              impuestoTotalExenta: parseInt(this.comisionesEuro.total.impuestoTotalExenta),
              totalExenta : parseInt(this.comisionesEuro.total.totalExenta)
            };
            comisiones.push(unaComision);
          }
          if(this.tipoCambioDA)
          {
            let unaComision = {
              moneda : "DA",
              impuestoTotalAfecta : parseInt(this.comisionesDA.total.impuestoTotalAfecta), 
              totalAfecta :this.comisionesDA.total.totalAfecta,
              impuestoTotalExenta: this.comisionesDA.total.impuestoTotalExenta,
              totalExenta : parseInt(this.comisionesDA.total.totalExenta)
            };
            comisiones.push(unaComision);
          }
          if(this.tipoCambioASB)
          {
            let unaComision = {
              moneda : "ASB",
              impuestoTotalAfecta : parseInt(this.comisionesASB.total.impuestoTotalAfecta), 
              totalAfecta :this.comisionesASB.total.totalAfecta,
              impuestoTotalExenta: this.comisionesASB.total.impuestoTotalExenta,
              totalExenta : parseInt(this.comisionesASB.total.totalExenta)
            };
            comisiones.push(unaComision);
          }
        }

      // Only require exenta file if the exenta input is actually visible (v-show keeps it in the DOM even when hidden)
      const exentaInputEl = this.$el.querySelector('input[type="file"][id*="Exenta"], input[type="file"][name*="Exenta"]');
      const exentaInputInDom = !!exentaInputEl && exentaInputEl.offsetParent !== null;
      const tipoDocumentoActivo = this.obtenerTipoDocumentoActivo();

      if (this.existeAfecta && this.existeExenta) {
        datos = {
          tipoDocumento :tipoDocumentoActivo,
          numeroDocumento: this.$v.form.numeroDocumento.$model,
          numeroDocumentoExenta: this.$v.form.numeroDocumentoExenta.$model,
          montoNetoAfecta: parseFloat(this.$v.form.montoNetoAfecta.$model.toString().replace(",", ".")),
          ivaAfecta: parseFloat(this.$v.form.ivaAfecta.$model.toString().replace(".", "").replace(".", "")),
          montoTotalAfecta: parseFloat(this.$v.form.montoTotalAfecta.$model.toString().replace(".", "").replace(".", "")),
          montoNetoExenta: parseFloat(this.$v.form.montoNetoExenta.$model??"0".toString().replace(",", ".")),
          ivaExenta: parseFloat(this.$v.form.ivaExenta.$model??"0".toString().replace(".", "").replace(".", "")),
          montoTotalExenta: parseFloat(this.$v.form.montoTotalExenta.$model??"0".toString().replace(".", "").replace(".", "")),
          fechaFacturacionBoleta: this.$v.form.fechaFacturacionBoleta.$model,
          fechaFacturacionBoletaExenta: this.$v.form.fechaFacturacionBoletaExenta.$model??null,
          archivo: base64Afecta,
          archivoExenta: exentaInputInDom ? base64Exenta : base64Afecta,
          facturacionComisionId: this.comision[0].facturacionComisionId,
          liquidacionId: this.comision[0].liquidacionId,
          mes: this.comision[0].mes,
          anio: this.comision[0].anio,
          rutCorredor: this.comision[0].rutCorredor,
          existeAfecta: this.existeAfecta,
          existeExenta: this.existeExenta,
          codigoAgente: this.codigoAgente,
          esRetencionOpcional: this.esRetencionOpcional,
          comisiones : comisiones
        };
      } else if (this.existeAfecta && this.existeExenta == false) {
        datos = {
          tipoDocumento :tipoDocumentoActivo,
          numeroDocumento: this.$v.form.numeroDocumento.$model,
          montoNetoAfecta: parseFloat(this.$v.form.montoNetoAfecta.$model.toString().replace(",", ".")),
          ivaAfecta: parseFloat(this.$v.form.ivaAfecta.$model.toString().replace(".", "").replace(".", "")),
          montoTotalAfecta: parseFloat(this.$v.form.montoTotalAfecta.$model.toString().replace(".", "").replace(".", "")),
          fechaFacturacionBoleta: this.$v.form.fechaFacturacionBoleta.$model,
          archivo: base64Afecta,          
          facturacionComisionId: this.comision[0].facturacionComisionId,
          liquidacionId: this.comision[0].liquidacionId,
          mes: this.comision[0].mes,
          anio: this.comision[0].anio,
          rutCorredor: this.comision[0].rutCorredor,
          existeAfecta: this.existeAfecta,
          existeExenta: this.existeExenta,
          codigoAgente: this.codigoAgente,
          esRetencionOpcional: this.esRetencionOpcional,
          comisiones : comisiones
        };
      } else if (this.existeAfecta == false && this.existeExenta) {
        datos = {
          tipoDocumento :tipoDocumentoActivo,
          numeroDocumentoExenta: this.$v.form.numeroDocumentoExenta.$model,
          montoNetoExenta: parseFloat(this.$v.form.montoNetoExenta.$model.toString().replace(",", ".")),
          ivaExenta: parseFloat(this.$v.form.ivaExenta.$model.toString().replace(".", "").replace(".", "")),
          montoTotalExenta: parseFloat(this.$v.form.montoTotalExenta.$model.toString().replace(".", "").replace(".", "")),          
          fechaFacturacionBoletaExenta: this.$v.form.fechaFacturacionBoletaExenta.$model == "" ? null:this.$v.form.fechaFacturacionBoletaExenta.$model,          
          archivoExenta: base64Exenta,
          facturacionComisionId: this.comision[0].facturacionComisionId,
          liquidacionId: this.comision[0].liquidacionId,
          mes: this.comision[0].mes,
          anio: this.comision[0].anio,
          rutCorredor: this.comision[0].rutCorredor,
          existeAfecta: this.existeAfecta,
          existeExenta: this.existeExenta,
          codigoAgente: this.codigoAgente,
          esRetencionOpcional: this.esRetencionOpcional,
          comisiones : comisiones
        };
      }
      
      if (datos.archivo == null && this.existeAfecta == true) {
        this.makeToast(false,"Favor adjuntar factura o boleta.","Aviso","Warning");
        submitButton.classList.remove("spinner","spinner-light","spinner-right");
        return;
      } else if (datos.archivoExenta == null && this.existeExenta == true && tipoDocumentoActivo != 'BOLETA' && exentaInputInDom) {
        this.makeToast(false,"Favor adjuntar factura o boleta.","Aviso","Warning");
        submitButton.classList.remove("spinner","spinner-light","spinner-right");
        return;
      } else {
        if (
          this.esRetencionOpcional &&
          this.existeAfecta &&
          this.existeExenta
        ) {
          if (
            datos.montoNetoAfecta.toString() !=
            this.comisionesUf.total.netoTotalAfecta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Afecta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
          if (
            datos.ivaAfecta.toString() !=
            this.comisionesUf.total.impuestoTotalAfecta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Afecta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
          if (
            datos.montoTotalAfecta.toString() !=
            this.comisionesUf.total.totalAfecta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Afecta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
          if (
            datos.montoNetoExenta.toString() !=
            this.comisionesUf.total.netoTotalExenta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Exenta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
          if (
            datos.ivaExenta.toString() !=
            this.comisionesUf.total.impuestoTotalExenta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Exenta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
          if (
            datos.montoTotalExenta.toString() !=
            this.comisionesUf.total.totalExenta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Exenta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
        } else if (
          this.esRetencionOpcional &&
          this.existeAfecta &&
          this.existeExenta == false
        ) {
          if (
            datos.montoNetoAfecta.toString() !=
            this.comisionesUf.total.netoTotalAfecta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Afecta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
          if (
            datos.ivaAfecta.toString() !=
            this.comisionesUf.total.impuestoTotalAfecta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Afecta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
          if (
            datos.montoTotalAfecta.toString() !=
            this.comisionesUf.total.totalAfecta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Afecta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
        }
        if (
          this.esRetencionOpcional &&
          this.existeAfecta == false &&
          this.existeExenta
        ) {
          if (
            datos.montoNetoExenta.toString() !=
            this.comisionesUf.total.netoTotalExenta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Exenta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
          if (
            datos.ivaExenta.toString() !=
            this.comisionesUf.total.impuestoTotalExenta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Exenta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
          if (
            datos.montoTotalExenta.toString() !=
            this.comisionesUf.total.totalExenta.toString()
          ) {
            this.makeToast(
              false,
              "Monto Exenta ingresado no es válido",
              "Aviso",
              "Warning"
            );
            return;
          }
        }

        
        this.$store
          .dispatch(SUBIR_ARCHIVO_BOLETA_FACTURA, datos)
          .then((resultado) => {
            let mensajeError = [];
            if (resultado.montoNetoAfecta == false) {
              mensajeError.push("Monto Neto Afecta");
            }
            if (resultado.ivaAfecta == false) {
              mensajeError.push("Iva Afecta");
            }
            if (resultado.montoTotalAfecta == false) {
              mensajeError.push("Monto Total Afecta");
            }
            if (resultado.montoNetoExenta == false) {
              mensajeError.push("Monto Neto Exenta");
            }
            if (resultado.ivaExenta == false) {
              mensajeError.push("Iva Exenta");
            }
            if (resultado.montoTotalExenta == false) {
              mensajeError.push("Monto Total Exenta");
            }
            if (mensajeError.length > 0) {
              this.mensaje.titulo = "Los siguientes montos no coinciden";
              this.mensaje.mensajes = mensajeError;
              this.mensaje.tipoMensaje = "danger";
              this.mensaje.mostrar = true;
              submitButton.classList.remove(
                "spinner",
                "spinner-light",
                "spinner-right"
              );
            } else {
              //Cierre de modal
              this.$bvModal.hide("modal-detalle-comision");
              submitButton.classList.remove(
                "spinner",
                "spinner-light",
                "spinner-right"
              );
              if (resultado.statusCode == 208) {
                Swal.fire({
                  title: "<strong>¡Importante!</strong>",
                  icon: "info",
                  text:
                    "Estimado Corredor, se ha subido el documento con exito, favor considerar que se pagará en el siguiente proceso de pago.",
                  showCloseButton: true,
                  focusConfirm: false,
                  confirmButtonText:
                    '<i class="fa fa-thumbs-up"></i> Deacuerdo!',
                  confirmButtonAriaLabel: "Deacuerdo",
                });
              } else if (resultado.statusCode == 201) {
                Swal.fire({
                  icon: "success",
                  title: "Aviso",
                  text: "Documento cargado correctamente",
                });
              }
              this.dialog = false;
              this.$bus.$emit("resultadoSubida", true);
            }
          })
          .catch((error) => {
            if (error != null) {
              let mensajeError = [];
              if (error.montoNetoAfecta == false) {
                mensajeError.push("Monto Neto Afecta");
              }
              if (error.ivaAfecta == false) {
                mensajeError.push("Iva Afecta");
              }
              if (error.montoTotalAfecta == false) {
                mensajeError.push("Monto Total Afecta");
              }
              if (error.montoNetoExenta == false) {
                mensajeError.push("Monto Neto Exenta");
              }
              if (error.ivaExenta == false) {
                mensajeError.push("Iva Exenta");
              }
              if (error.montoTotalExenta == false) {
                mensajeError.push("Monto Total Exenta");
              }
              if (mensajeError.length > 0) {
                this.mensaje.titulo = "Los siguientes montos no coinciden";
                this.mensaje.mensajes = mensajeError;
                this.mensaje.tipoMensaje = "danger";
                this.mensaje.mostrar = true;
              }
              this.makeToast(
                false,
                "Hubo un problema al procesar la solicitud, favor vuelva a confirmar los montos ingresados",
                "Aviso",
                "Warning"
              );
              submitButton.classList.remove(
                "spinner",
                "spinner-light",
                "spinner-right"
              );
            } else {
              this.makeToast(
                false,
                "Hubo un problema al procesar la solicitud, el usuario no existe",
                "Aviso",
                "Warning"
              );
              submitButton.classList.remove(
                "spinner",
                "spinner-light",
                "spinner-right"
              );
            }
          });
      }
    },
  },
};
</script>

<style>
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Examinar";
}

.bordeFormulario {
  border-color: darkgray;
  border-radius: 10px;
}

.fondoUf {
  background-color: #1984ae;
  color: white;
}

.fondoDolar {
  background-color: #1984ae;
  color: white;
}
.fondoUTM {
  background-color: #cc9a12;
  color: white;
}
.fondoEuro {
  background-color: #12c0cc;
  color: white;
}

.divisor {
  margin-top: -5px;
  margin-bottom: -20px;
}

.ajusteTexto {
  margin-bottom: -10px;
}

/* .toast-header strong{
  font-size: 12px !important;
}
.toast-body{
      font-size: 14px !important;
} */
</style>

<style scoped>

.invalid-feedback{
    color:#fff !important
  }

  .texto-derecha {
  text-align: right;
}
</style>
